<div class="dialog-content" >
  <div class="logo-container">
    <img class="logo confirm" alt="check-confirm" src="../../../../../../assets/images/extra/confirmed.svg" />
  </div>

  <span class="hour">{{hour}}</span>
  <p class="title">{{title}}</p>

</div>